export default [
    {
        path: '/reports',
        name: 'Reports',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
            title: 'Reports',
        },
        components: {
            default: () => import('@views/reports/ReportsIndex.vue'),
        },
    },
    {
        path: '/reports/create',
        name: 'ReportsCreate',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER'],
            denyRoles: null,
            title: 'Create report',
        },
        components: {
            default: () => import('@views/reports/ReportsCreate.vue'),
        },
    },
    {
        path: '/reports/:id/edit',
        name: 'ReportsEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER'],
            denyRoles: null,
            title: 'Edit report',
        },
        components: {
            default: () => import('@views/reports/ReportsEdit.vue'),
        },
    },
    {
        path: '/reports/:id/view',
        name: 'ReportsView',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
            title: 'View report',
            fullHeight: true,
        },
        components: {
            default: () => import('@views/reports/ReportsView.vue'),
        },
    },
];
